import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1320212723322841';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    requestIdleCallback?: (cb: () => void, opts?: {
      timeout: number;
    }) => number;
  }
}
function loadPixel() {
  if (typeof window === 'undefined') return;
  // Avoid double-initialization (e.g. React strict mode / re-mounts)
  if (window.fbq) {
    window.fbq('track', 'PageView');
    return;
  }
  /* eslint-disable */
  ;
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      ;
      (b.head || b.documentElement).appendChild(t);
    }
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function MetaPixel() {
  useEffect(() => {
    // Defer the (render-blocking) Facebook script until the browser is idle,
    // so it never competes with the LCP / first paint on mobile.
    if (typeof window === 'undefined') return;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(loadPixel, {
        timeout: 4000
      });
    } else {
      const id = setTimeout(loadPixel, 2500);
      return () => clearTimeout(id);
    }
  }, []);
  return null;
}